import AMapLoader from "@amap/amap-jsapi-loader"
import store from "@/store";
import router from "@/router";
import axiosApi, {$_ajax} from "@/utils/axiosApi";
import {ElMessage} from "element-plus";
import {computed} from "vue";
import {Base64} from "js-base64";

export const getCity = () => {
    AMapLoader.load({
        'key': '92cd048e351337fbb4117525a41f4950',
        'version': '2.0',
        'plugins': ['AMap.CitySearch']//根据当前ip地址获取用户所在城市信息
    }).then(AMap => {
        let city = new AMap.CitySearch();
        city.getLocalCity((state, res) => {
            if (state === "complete") {
                store.commit("getCity", {name: res.city})
            }
        })
    })
}

export const routerUrl = (checkLogin, goToBack, param, query) => {
    const items = {
        name: goToBack,
        params: param,
        query
    }
    //校验登录
    if (!checkLogin) {
        //不需要校验，直接登录
        router.replace(items);
        return
    }
    //获取会员信息
    store.commit("getAccount")
    const account = computed(()=>store.state.account)
    // console.log(account.value);
    // return ;
    if (Object.keys(account.value).length < 1) {
        return _message("请登录", "error", 3000, () => router.replace({
            name: 'login', query: {
                name: goToBack,
                params: param ? JSON.stringify(param) : null,
                query: query ? JSON.stringify(query) : null
            }
        }))
    }
    new axiosApi({
        encode: "site",
        method: "user/check_login",
        body: {
            cust_id: account.value.cust_id,
            token: account.value.token
        }
    }).send((res) => {
        if (res.message.code !== "000") {
            return _message("请登录", "error", 3000, () => {
                store.commit("removeAccount")
                router.replace({
                    name: 'login', query: {
                        name: goToBack,
                        params: param ? JSON.stringify(param) : null,
                        query: query ? JSON.stringify(query) : null
                    }
                })
            })
        }
        res.data.phoneNumber = Base64.decode(res.data.phoneNumber)
        store.commit("getAccount", res.data)
        router.replace(items)
    }, () => {
        return _message("请登录", "error", 3000, () => {
            store.commit("removeAccount")
            router.replace({
                name: 'login', query: {
                    name: goToBack,
                    params: param ? JSON.stringify(param) : null,
                    query: query ? JSON.stringify(query) : null
                }
            })
        })
    });
}

export const _message = (message, type, duration = 3000, callback = null) => {
    return ElMessage({
        type,
        message,
        duration,
        onClose: () => {
            if (callback) {
                callback()
            }
        }
    })
}

export const onWayFn = (query) => {
    $_ajax(`${process.env.VUE_APP_ONE_WAY}scal/check`, {params: query}).then((data) => {
        if (data.data && data.data.data) {
            data.data.data.phoneNumber = Base64.decode(data.data.data.phoneNumber)
            store.commit("getAccount", data.data.data)
        } else {
            store.commit("removeAccount")
        }
    }).catch(() => store.commit("removeAccount"));
}
